import { cn } from "@/src/lib/utils";
import { Heading, Text } from "@/src/components/ui/Typography";

import type { FaqAccordionItemData } from "./FaqAccordion.types";

interface FaqAccordionItemProps {
  item: FaqAccordionItemData;
  open: boolean;
  onToggle: () => void;
  index: number;
}

export function FaqAccordionItem({
  item,
  open,
  onToggle,
  index,
}: FaqAccordionItemProps) {
  return (
    <div className="border-b border-neutral-400 py-8 first:pt-0">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        className="flex w-full items-start justify-between text-left"
      >
        <Text
          as="span"
          size="bodyLG"
          className="mt-2 w-6 shrink-0 text-neutral-700"
        >
          {index}
        </Text>
        <div className="flex min-w-[75%] max-w-[75%] flex-col gap-4">
          <div className="flex gap-4 w-full">
            <Heading
              as="h3"
              size="headingLG"
              className="flex-1 text-neutral-700 max-w-full wrap-break-word"
            >
              {item.title}
            </Heading>

            <div className="relative mt-2 h-5 w-5 shrink-0 text-neutral-500">
              <span className="absolute top-1/2 left-0 h-px w-full -translate-y-1/2 bg-current" />
              <span
                className={cn(
                  "absolute top-0 left-1/2 h-full w-px -translate-x-1/2 bg-current transition-transform duration-550 ease-out",
                  open && "rotate-90",
                )}
              />
            </div>
          </div>
          <div
            className={cn(
              "grid overflow-hidden transition-all duration-750 ease-[cubic-bezier(.22,1,.36,1)]",
              open
                ? "grid-rows-[1fr] opacity-100"
                : "grid-rows-[0fr] opacity-0",
            )}
          >
            <div className="min-h-0 overflow-hidden">
              <Text size="bodySM" className="max-w-[90%] text-neutral-600">
                {item.content}
              </Text>
            </div>
          </div>
        </div>
      </button>
    </div>
  );
}
